var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgViewIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0D68F9",
  d: "m11.02 10.079 2.856 2.854-.944.944-2.854-2.856A6.002 6.002 0 0 1 .333 6.334c0-3.312 2.688-6 6-6a6.002 6.002 0 0 1 4.687 9.745m-1.337-.495a4.665 4.665 0 0 0-3.35-7.917 4.665 4.665 0 0 0-4.667 4.667 4.665 4.665 0 0 0 7.917 3.35zm-2.565-5.8A1.333 1.333 0 1 0 8.882 5.55a2.667 2.667 0 1 1-1.764-1.764"
})));
export { SvgViewIcon as ReactComponent };
export default __webpack_public_path__ + "b3cf7aa714ce70c5000459d667ecb278.svg";